import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/qrConfigs',
        name: 'qrConfigs',
        component: () => import("./views/qrConfigs.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User, CONST.AppRoles.Guest]
        }
    },
    {
        path: '/qrConfigs/import',
        name: 'excelImport',
        component: () => import("./views/excelImport.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User],
            hideHelpButton: true
        }
    },
    {
        path: '/qrConfigs/import/:identifier',
        name: 'excelImportDetail',
        component: () => import("./views/excelImportDetail.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User],
            hideHelpButton: true
        }
    },
    {
        path: '/qrConfigs/:identifier',
        name: 'qrConfigDetail',
        component: () => import("./views/qrConfigDetail.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User, CONST.AppRoles.Guest],
            hideHelpButton: true
        }
    },
];

export default routes;